import { values } from "lodash";

import untypedItems from "@data/items.json";

import type { Item, ItemsJson } from "@typings/product/item";

const items: ItemsJson = untypedItems as ItemsJson;

export default (not: number[]): Item[] => {
  const upsells = values(items).filter((i) => i.tags.some((t) => t.name === "Upsell"));

  return upsells.filter((u) => !not.includes(u.id));
};
